import { Component, Input } from '@angular/core';
import { SurveyJob } from 'src/app/shared/survey-data-services/survey-job';

@Component({
    selector: 'edit-job-header',
    templateUrl: './edit-job-header.component.html'
})
export class EditJobHeaderComponent {
    @Input() job: SurveyJob;
}
